import { render, staticRenderFns } from "./spot.vue?vue&type=template&id=35b315f6&"
import script from "./spot.vue?vue&type=script&lang=ts&"
export * from "./spot.vue?vue&type=script&lang=ts&"
import style0 from "./spot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports